export default class MonthSummary {
  year = ''
  month = ''
  count = ''
  localeMonthStr = ''

  getCount = function (argument) {
    if (this.count > 999) {
      return '999+'
    } else {
      return this.count
    }
  }

  get dateStr () {
    return this.year + '' + this.month
  }
}



// WEBPACK FOOTER //
// ./src/common/model/MonthSummary.js